import React from 'react'
import kebabCase from 'lodash.kebabcase'
import classNames from 'classnames'
import { SizeOptions, Text } from 'marketing-site/src/library/elements/Text'
import { LegacyColor, fontGraphik, mq } from 'marketing-site/src/library/utils'
import { Result as ResultDefault } from './result'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

export interface IProps {
  caption: string
  timeUnit: string
  resultNumber: number
  isFormSubmitted: boolean
  tooltipText: string
  isComputerScreen: boolean
  currency?: string
}

function ResultLegacy(props: IProps) {
  const {
    caption,
    timeUnit,
    resultNumber,
    isFormSubmitted,
    tooltipText,
    isComputerScreen,
    currency,
  } = props
  const resultString = resultNumber.toLocaleString()
  const numberClassnames = classNames(['number', { gray: !isFormSubmitted }])
  const numberFontSize: SizeOptions = isComputerScreen ? 'xxl+' : 'xl'

  return (
    <>
      <div className="result">
        <div className="result-caption">
          <Text size="xl+">{caption}</Text>
          <span className="no-wrap-container">
            <span className="slash" aria-hidden="true">
              /
            </span>
            <Text size="body" aria-hidden="true">
              {timeUnit}
            </Text>
            <span className="tooltip-container">
              <span className="tooltip" aria-hidden="true">
                ?
              </span>
              <div className="tooltip-text">
                <Text size="caption">{tooltipText}</Text>
              </div>
            </span>
          </span>
        </div>
        <div className={numberClassnames} data-testid={`${kebabCase(caption)}-output`}>
          <Text size={numberFontSize}>
            {currency ? `${currency}${resultString}` : resultString}
          </Text>
        </div>
      </div>
      <style jsx>
        {`
          .result {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 50px;

            .result-caption {
              display: inline-block;

              :global(span) {
                font-weight: normal;
              }

              .slash {
                margin: 0 5px;
              }

              .no-wrap-container {
                white-space: nowrap;
              }

              .tooltip-container {
                display: inline-block;
                position: relative;
                background: ${LegacyColor.LightGray};
                width: 25px;
                border-radius: 15px;
                padding: 7px 10px;
                margin-left: 5px;
                font-size: 10px;
                vertical-align: super;
                white-space: normal;

                .tooltip {
                  font-family: ${fontGraphik};
                  font-weight: bold;
                }

                .tooltip-text {
                  width: 250px;
                  padding: 8px;
                  background: ${LegacyColor.LightGray};
                  border-radius: 6px;
                  position: absolute;
                  left: -110px;
                  bottom: 48px;
                  opacity: 0;
                  transition: opacity $timing-fast;
                  pointer-events: none;
                }

                .tooltip-text::after {
                  position: absolute;
                  background: ${LegacyColor.LightGray};
                  height: 15px;
                  width: 15px;
                  content: ' ';
                  transform: rotate(45deg);
                  border-radius: 2px;
                  left: 46%;
                  bottom: -8px;

                  opacity: 0;
                  transition: opacity $timing-fast;
                  pointer-events: none;
                }
              }

              .tooltip-container:hover {
                .tooltip-text::after,
                .tooltip-text {
                  opacity: 1;
                }
              }
            }

            .number {
              margin-left: 20px;
              align-self: end;

              &.gray {
                color: ${LegacyColor.UIGray};
              }
            }
          }

          @media (${mq.laptop}) {
            .result {
              margin-top: 60px;
              margin-bottom: 0px;

              .number {
                margin-left: 60px;
              }
            }
          }
        `}
      </style>
    </>
  )
}

export const Result = NewBrandingHoc(ResultLegacy, ResultDefault)
